const htmlTemplate = `
    <div class="registration-button-container">
        <h2>Register now</h2>
        <form>
            <div class="form-group">
                <div class="input-wrapper">
                    <input placeholder="Enter your email to register" aria-label="Enter your email to register">
                    <button>Register now</button>
                </div>
            </div>
        </form>
    </div>
`;

const cssCode = `
.registration-button-container {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    --container-max-columns: 12;
    --grid-vertical-gap: 40px;
    --container-max-width: 1200px;
    --button-background-color: #FF8815;
    --button-foreground-color: #FFFFFF;
    --utility-color: 29,100%;
    --utility-color-light: 54.1%;
    -webkit-font-smoothing: antialiased;
    font-weight: 400;
    accent-color: var(--button-background-color);
    font-family: 'Raleway',sans-serif;
    font-size: 1rem;
    line-height: 1.5;
    color: #000000;
    --bs-gutter-x: 0px;
    --bs-gutter-y: 0;
    background-color: white;
    border-radius: 12px;
    border: 1px solid #e5e6e6;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
    padding: 16px;
    margin-bottom: 0;
}

.registration-button-container h2 {
    accent-color: var(--button-background-color);
    margin: 0 0 8px;
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.875rem;
}

.registration-button-container form div.form-group {
    margin-bottom: 16px;
}

.registration-button-container form .form-group .input-wrapper {
    display: flex;
}

.registration-button-container form .form-group .input-wrapper input {
    accent-color: var(--button-background-color);
    margin: 0;
    padding: 7px 12px;
    display: block;
    box-sizing: border-box;
    border: 1px solid #e5e6e6;
    border-radius: 8px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    width: auto;
    flex: 1 1 auto;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-color: var(--button-background-color);
}

.registration-button-container form .form-group .input-wrapper button {
    margin: 0;
    text-transform: none;
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    appearance: none;
    border-radius: 8px;
    border: 0;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, color 0.15s ease-in-out, opacity 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    background-color: hsl(var(--utility-color), var(--utility-color-light));
    color: var(--button-foreground-color);
    padding: 8px 12px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    flex: 0 1 auto;
}
`;

export default `
unlayer.registerTool({
    name: 'register_button',
    label: 'Registration Form',
    icon: 'fa-input-pipe',
    supportedDisplayModes: ['web'],
    values: {},
    renderer: {
        Viewer: unlayer.createViewer({
            render(values) {return \`${htmlTemplate}\`;}
        }),
        exporters: {
            web: function (values) {return \`${htmlTemplate}\`;}
        },
        head: {
            css: function (values) {
                return \`${cssCode}\`;
            },
            js: function (values) {
                return '';
            }
        }
    }
});`;
